import { call, put, takeEvery, takeLatest } from "redux-saga/effects"
import { showErrorMessages } from "helpers/helpers"

import {
  UPDATE_SUPPLIER,
  GET_ALL_SUPPLIERS,
  CREATE_SUPPLIER,
} from "./actionTypes"
import {
  getAllSuppliersCall,
  createSupplierCall,
  updateSupplierCall,
} from "../../helpers/repository"
import { getAllSuppliersResponseSuccess } from "./actions"
import { showMessage } from "components/Common/Toaster"
import { apiError } from "store/actions"
import { getAllSuppliers } from "store/suppliers/actions"

function* attemptGetAllSuppliers() {
  try {
    const response = yield call(getAllSuppliersCall)
    yield put(getAllSuppliersResponseSuccess(response.data.data.suppliers))
  } catch (error) {
    showErrorMessages(error)
  }
}

function* attemptCreateSupplier(action) {
  const { history } = action
  try {
    const response = yield call(createSupplierCall, action.payload)
    showMessage("success", response.data.message)
    history.push("/supplier-commissions")
  } catch (error) {
    yield put(apiError(error?.response?.data?.errors))
    showErrorMessages(error)
  }
}

// -------------------------------------------------------EDIT------------------------------------------------------
function* attemptUpdateSupplier(action) {
  const { history, redirectTo } = action
  try {
    const response = yield call(updateSupplierCall, action.payload)
    showMessage("success", response.data.message)
    yield put(getAllSuppliers())
    history.push(`/supplier-commissions`)
  } catch (error) {
    yield put(apiError(error?.response?.data?.errors))
  }
}

function* SuppliersSaga() {
  yield takeEvery(GET_ALL_SUPPLIERS, attemptGetAllSuppliers)
  yield takeEvery(CREATE_SUPPLIER, attemptCreateSupplier)
  yield takeEvery(UPDATE_SUPPLIER, attemptUpdateSupplier)
}

export default SuppliersSaga
